var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal",
    {
      staticClass: "create-holidays-popup",
      attrs: { transition: 0, "append-to-body": true, backdrop: false },
      model: {
        value: _vm.opened,
        callback: function ($$v) {
          _vm.opened = $$v
        },
        expression: "opened",
      },
    },
    [
      _c("div", { attrs: { slot: "header" }, slot: "header" }, [
        _c("a", {
          attrs: { id: "close_popup" },
          on: { click: _vm.closePopup },
        }),
        _vm._v(" "),
        _c("h3", { staticClass: "modal-title" }, [_vm._v(_vm._s(_vm.header))]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-sm-12" }, [
          _vm._v(
            "\n            Are You sure you want to delete this Holiday?\n        "
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.allowDeleteFromOtherGroups
        ? _c("div", { staticClass: "row margin-15-top" }, [
            _c(
              "div",
              { staticClass: "col-sm-6" },
              [
                _c("vue-switch-with-label", {
                  attrs: {
                    label: "Delete from other Groups",
                    value: _vm.deleteFromAnotherGroups,
                    name: "addInAnotherGroups",
                  },
                  on: { input: _vm.onDeleteFromAnotherGroupsChanged },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _vm.groupsToDeleteIdList.length
              ? _c(
                  "div",
                  {
                    staticClass: "col-sm-6",
                    staticStyle: { "line-height": "31px" },
                  },
                  [
                    _vm._v("\n            Holiday will be deleted from "),
                    _c("strong", [
                      _vm._v(_vm._s(_vm.groupsToDeleteIdList.length)),
                    ]),
                    _vm._v(" Group"),
                    _vm.groupsToDeleteIdList.length > 1
                      ? _c("span", [_vm._v("s")])
                      : _vm._e(),
                    _vm._v(".\n        "),
                  ]
                )
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
        _c(
          "button",
          { staticClass: "btn btn-mm", on: { click: _vm.closePopup } },
          [_vm._v("Cancel")]
        ),
        _vm._v(" "),
        _c(
          "button",
          { staticClass: "btn btn-mm btn-red", on: { click: _vm.del } },
          [_vm._v("\n            Delete\n        ")]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }